var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"button",attrs:{"type":"is-primary"},on:{"click":this.exporter}},[_c('b-icon',{attrs:{"pack":"fas","icon":"file-excel"}}),_c('span',[_vm._v(_vm._s(' ')+_vm._s(_vm.$t("insight.exporter_xls")))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }